import { store } from '../../index';
import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { Grid, Typography, Divider, Button, CircularProgress, IconButton } from "@material-ui/core";

import ChevronLeftTwoToneIcon from "@mui/icons-material/ChevronLeftTwoTone";
import MenuIcon from "@mui/icons-material/Menu";
import PhoneIcon from "@mui/icons-material/Phone";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import AccountCircleTwoToneIcon from "@mui/icons-material/AccountCircleTwoTone";
import Sheet from "@mui/joy/Sheet";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";

import defaultimg from "../../assets/images/default.png";
import VegIcon from "../../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../../assets/images/Non Veg Icon 1.svg";
import cart from "../../assets/images/basket.svg";
import CouponImg from "../../assets/img/Coupon.png";
import HomeIcon from "@mui/icons-material/ChevronLeft";
import CyntraLogo from "../../assets/images/cyntra_logo.svg";
import EmptyOrder from "../../assets/images/EmptyOrder.svg";
import { hexToCSSFilter } from "hex-to-css-filter";

import LeaveCartPopup from "../../components/LeaveCartPopup";
import SignInPopup from "../login/SignInPopup";
import { get_customer_list } from "../../utils/customer_helper";
import { displayRazorpay } from "../../components/razorpay/Rezorpay";
import { paytmPayment } from "../../components/paytm/Paytm";
import { closeOrderViaSaveOrder, get_table_orders } from "../../utils/order_helper";
import { get_tender } from "../../utils/item_helper";
import { set_last_order, set_customer, clear_customer, order_place, clear_last_order, set_tender, store_offers, clear_applied_offer } from "../../store/actions/action";
import { removeDiscount, addTip } from "../../store/actions/cartActions";
import { store_offer } from "../../utils/store_helper";
import { BUTTON_COLOR, TOKEN_KEY } from "../../utils/constant";
import FSRPayBillOffers from "../checkout/FSRPayBillOffers";
import { getFSRFlow, getFSRTableId, getFSRTableDisplayName, stripTablePrefix, getFSRTableCacheKey } from "../../utils/fsr_helper";
import { act } from "react";

const FRAME_WIDTH = 814;
const getFrameFixed = () => {
  if (window.innerWidth >= 768) {
    const offset = `calc(50% - ${FRAME_WIDTH / 2}px)`;
    return { left: offset, right: offset, width: `${FRAME_WIDTH}px` };
  }
  return { left: "0px", right: "0px", width: "100%" };
};

function FSROrders(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { reducer, set_last_order, set_customer, set_tender } = props;
  const { customer, last_order } = reducer;

  const sessionReducer = useSelector(state => state.sessionReducer);
  const business_date = sessionReducer?.store_details?.business_date;

  // Use sessionReducer for config first, fallback to old reducer
  const storeInfoConfig = sessionReducer?.store_config || sessionReducer?.store_config || {};
  const storeInfo = sessionReducer?.store_details || sessionReducer?.store_details || {};

  const activeTab = location.state?.activeTab || "orders";

  const [activeOrder, setActiveOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [frameFixed, setFrameFixed] = useState(getFrameFixed());
  const [couponOpen, setCouponOpen] = useState(false);
  const [tipValue, setTipValue] = useState(0);
  const [openLeaveCartPopup, setOpenLeaveCartPopup] = useState(false);

  const cartProps = useSelector((s) => s.cartReducer) || {};
  // Flipped true right before navigating to /checkout so the pay-tab
  // cleanup effect doesn't discard the offer the user just applied.
  const proceedingToCheckoutRef = useRef(false);

  const handleSidebarOpen = () => setOpenSidebar(true);
  const handleSidebarClose = () => setOpenSidebar(false);

  const groupItems = (itemDetails) => {
    if (!itemDetails || !Array.isArray(itemDetails)) return [];

    const mainItems = [];
    const subItemsMap = {};

    // Group all items that have a main_item_id
    itemDetails.forEach((item) => {
      const mainId = item.main_item_id;
      if (mainId) {
        if (!subItemsMap[mainId]) {
          subItemsMap[mainId] = [];
        }
        subItemsMap[mainId].push(item);
      }
    });

    // Collect main items (those without a main_item_id, or whose main_item_id's parent is not in the list)
    itemDetails.forEach((item) => {
      if (!item.main_item_id) {
        mainItems.push({
          ...item,
          subItems: [],
        });
      } else {
        const parentExists = itemDetails.some(
          (p) => String(p._id) === String(item.main_item_id) ||
            String(p.item_id) === String(item.main_item_id) ||
            String(p.sku) === String(item.main_item_id)
        );
        if (!parentExists) {
          mainItems.push({
            ...item,
            subItems: [],
          });
        }
      }
    });

    // Assign sub-items to their matching parents
    mainItems.forEach((parent) => {
      const subItems = [];
      const seenIds = new Set();

      const addSubItems = (list) => {
        if (list) {
          list.forEach((sub) => {
            if (!seenIds.has(sub)) {
              seenIds.add(sub);
              subItems.push(sub);
            }
          });
        }
      };

      if (parent._id) addSubItems(subItemsMap[parent._id]);
      if (parent.item_id) addSubItems(subItemsMap[parent.item_id]);
      if (parent.sku) addSubItems(subItemsMap[parent.sku]);

      parent.subItems = subItems;
    });

    return mainItems;
  };

  const getCumulativePrice = (parent) => {
    // The server-computed sub_total on the main item already includes the price
    // of its addons. Adding the flat addon rows' sub_totals on top would
    // double-count them (visible as inflated per-row prices on the Orders screen).
    return parseFloat(parent.sub_total || parent.total_net_sale || 0);
  };

  // Direct comparison using table_id from sessionReducer — no reconstruction needed.
  const isCurrentTableOrder = (order) => {
    const sessionTableId = getFSRFlow()?.table_id;
    const orderTableId = order?.store_details?.table_id || order?.table_id;
    if (sessionTableId && orderTableId) {
      return String(sessionTableId) === String(orderTableId);
    }
    // Fallback: compare table_no if table_id is not available
    const sessionTableNo = stripTablePrefix(getFSRFlow()?.table_no || "");
    const orderTableNo = stripTablePrefix(order?.store_details?.table_no || order?.table_no || "");
    return sessionTableNo && sessionTableNo === orderTableNo;
  };

  const tableNo = getFSRTableCacheKey();


  const primaryColor = storeInfoConfig?.general_config?.primary_color || "#272727";
  const storeCurrency = storeInfo?.store_currency || "INR";
  const currencySymbol = (() => {
    const currencyMap = {
      INR: "₹",
      USD: "$",
      CAD: "$",
      OMR: "OMR ",
      AED: "AED ",
    };
    return currencyMap[storeCurrency] || "$";
  })();

  useEffect(() => {
    const handleResize = () => setFrameFixed(getFrameFixed());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isOrderFromToday = (order) => {
    const rawDate = order?.business_date || order?.date_time || order?.created_at || "";
    const dateStr = rawDate.replace(" ", "T");
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;
    const orderDateOnly = dateStr.slice(0, 10); // "YYYY-MM-DD"
    if (business_date) {
      return orderDateOnly === business_date.slice(0, 10);
    }
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  };

  const isOpenOrder = (order) => {
    const status = (order?.order_status || "").toUpperCase();
    const state = (order?.order_state || "").toUpperCase();
    const isClosed = status === "CLOSE" || status === "CLOSED" || status === "COMPLETED" || status === "COMPLETE" || status === "CANCELLED" ||
      state === "CLOSE" || state === "CLOSED" || state === "CANCELLED";
    return status === "OPEN" && !isClosed;
  };

  const loadFromLocalStorage = () => {
    const savedOrderStr = (store.getState().customerReducer.active_table_orders[tableNo]?.order ? JSON.stringify(store.getState().customerReducer.active_table_orders[tableNo].order) : null);
    if (savedOrderStr) {
      const savedOrder = JSON.parse(savedOrderStr);
      const isToday = isOrderFromToday(savedOrder);
      if (isOpenOrder(savedOrder) && isToday) {
        setActiveOrder(savedOrder);
        store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo, data: { payBillEnabled: true } } });
      } else {
        setActiveOrder(null);
      }
    } else {
      setActiveOrder(null);
    }
  };

  const fetchRunningOrder = async () => {
    try {
      const isLoggedIn = customer?.cust_mobile && customer?.guest !== "Guest";
      let ordersArray = [];
      let customerResp = null;

      if (!isLoggedIn) {
        let sessionTableOrders = sessionReducer?.table_orders;

        // Fetch fresh data for No-Login Flow
        const apiTable = getFSRFlow();
        const store_id = sessionReducer?.store_details?.store_id || storeInfo?.store_id;
        const b_date = business_date;

        if (store_id && apiTable?.table_id && b_date) {
          try {
            const payload = { store_id, table_id: String(apiTable.table_id), business_date: b_date };
            const freshOrders = await get_table_orders(payload);
            if (freshOrders) {
              sessionTableOrders = freshOrders;
              store.dispatch({ type: "SET_TABLE_ORDERS", table_orders: freshOrders });
            }
          } catch (e) {
            console.error("[FSR-Orders] Error fetching fresh table orders:", e);
          }
        }

        ordersArray = Array.isArray(sessionTableOrders) ? sessionTableOrders : (sessionTableOrders?.data || []);
      } else {
        customerResp = await get_customer_list({ cust_mobile: customer?.cust_mobile });
        ordersArray = customerResp?.order_details || [];
      }

      if (ordersArray && ordersArray.length > 0) {
        let openOrder = null;
        if (tableNo) {
          openOrder = ordersArray
            .filter(order => isCurrentTableOrder(order) && isOpenOrder(order) && isOrderFromToday(order))
            .sort((a, b) => {
              const timeA = new Date(a?.date_time || a?.updated_at || a?.order_end_date_time || a?.created_at || 0).getTime();
              const timeB = new Date(b?.date_time || b?.updated_at || b?.order_end_date_time || b?.created_at || 0).getTime();
              return timeB - timeA;
            })[0] || null;
        }

        if (openOrder) {
          setActiveOrder(openOrder);
          if (customerResp) set_last_order(customerResp);
          const foundTableId = openOrder?.store_details?.table_no || openOrder?.table_no || "";
          const cacheKey = tableNo || foundTableId;
          store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { order: openOrder } } });
          store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { items: openOrder.item_details } } });
          store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: cacheKey, data: { payBillEnabled: true } } });
          store.dispatch({ type: 'SET_OFFLINE_INVOICE_NO', offline_invoice_no: openOrder?.offline_invoice_no || null });
        } else {
          setActiveOrder(null);
          store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo } });
          store.dispatch({ type: 'SET_OFFLINE_INVOICE_NO', offline_invoice_no: null });
          if (isLoggedIn && !customerResp?.order_details) loadFromLocalStorage();
        }
      } else {
        setActiveOrder(null);
        store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo } });
        store.dispatch({ type: 'SET_OFFLINE_INVOICE_NO', offline_invoice_no: null });
        if (isLoggedIn) loadFromLocalStorage();
      }
    } catch (err) {
      console.error("[FSR-Orders] Error fetching running order:", err);
      if (customer?.cust_mobile && customer?.guest !== "Guest") loadFromLocalStorage();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRunningOrder();
  }, [customer?.cust_mobile, location]);

  // Auto-enable/disable Pay Bill based on activeOrder
  useEffect(() => {
    if (activeOrder) {
      store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo, data: { payBillEnabled: true } } });
    } else {
      /* cleared above */
    }
  }, [activeOrder, tableNo]);

  // On entering pay-bill tab: refresh the offer list so the drawer always shows
  // the latest offers. Also discard any offer on unmount / tab-switch away from
  // pay so leaving without paying reverts totals to no discount.
  useEffect(() => {
    if (activeTab !== "pay") return;
    (async () => {
      try {
        const offers = await store_offer();
        if (offers) store.dispatch(store_offers(offers));
      } catch (e) {
        console.warn("[FSR-Orders] /offer/list fetch failed", e);
      }
    })();
    return () => {
      if (proceedingToCheckoutRef.current) {
        proceedingToCheckoutRef.current = false;
        return;
      }
      store.dispatch(removeDiscount());
      store.dispatch(clear_applied_offer());
      store.dispatch({ type: "CLEAR_ENGINE_DISCOUNT" });
      store.dispatch(addTip(0));
      setTipValue(0);
    };
  }, [activeTab]);

  const updateOrderStatus = async (paymentResp, order_status) => {
    const { paymentResponse, orders } = paymentResp;
    try {
      const finalOrderStatus = "CLOSE";
      const updatedOrders = (orders || [activeOrder]).map(order => ({
        ...order,
        order_status: finalOrderStatus,
      }));
      const resp = await closeOrderViaSaveOrder({
        order: updatedOrders[0],
        transResponse: paymentResponse || {},
        orderStatus: finalOrderStatus,
      });
      if (resp?.status) {
        // Order successfully paid and closed!
        // Clear caches and navigate to status screen
        props.order_place(updatedOrders);
        props.clear_last_order();
        store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo } });
        props.clearCart();
        setActiveOrder(null);
        navigate("/order-status");
      } else {
        alert("Something went wrong while updating order payment status!");
      }
    } catch (error) {
      console.error("[FSR-Orders] Error updating status:", error);
      alert("Error processing payment update. Please try again.");
    }
  };

  const handlePayNow = async () => {
    if (!activeOrder) return;

    // Navigate to Pay Bill tab
    navigate("/cart", { state: { fsrView: "orders", activeTab: "pay" } });

    const gateway = storeInfoConfig?.gateway?.payment_brand?.toLowerCase()?.trim() || "razorpay";

    // Use recalculated totals for gateway amount and tax
    const amount = recalculatedTotals.total;
    const total_tax = recalculatedTotals.tax;

    // Sync recalculated values into activeOrder so the server receives correct totals
    const updatedActiveOrder = {
      ...activeOrder,
      sub_total: recalculatedTotals.itemTotal,
      total_tax: recalculatedTotals.tax,
      total_discount: recalculatedTotals.discount,
      discount: recalculatedTotals.discount,
      total: recalculatedTotals.total,
      grand_total: recalculatedTotals.total,
      rounded_total: recalculatedTotals.total,
      round_off_amount: recalculatedTotals.roundOffAmount,
      transaction_grand_amount: recalculatedTotals.total,
      order_status: "CLOSE",
    };

    // Dynamically fetch tenders to prevent hardcoding payment fallbacks
    let storeTenderList = [];
    try {
      storeTenderList = await get_tender();
    } catch (e) {
      console.warn("Failed to fetch tender list dynamically", e);
    }

    const findTenderByType = (typeMatch) => {
      const match = typeMatch.toLowerCase();
      return (storeTenderList || []).find(t =>
        (t.tnd_type || "").toLowerCase().includes(match) ||
        (t.tnd_code || "").toLowerCase() === match
      ) || {};
    };

    // Wrapper function to ensure order_status is always "CLOSE" on payment completion
    const handlePaymentCallback = async (paymentResp) => {
      await updateOrderStatus(paymentResp, "CLOSE");
    };

    if (gateway === "razorpay") {
      const razorpayTender = findTenderByType("razorpay");
      if (razorpayTender && Object.keys(razorpayTender).length > 0) set_tender(razorpayTender);

      await displayRazorpay({
        store_id: storeInfo?.store_id,
        amount,
        total_tax,
        updateOrderStatus: handlePaymentCallback,
        customer: customer || {},
        orders: [updatedActiveOrder],
        setBtnDisable: () => { },
      });
    } else if (gateway === "paytm") {
      const paytmTender = findTenderByType("paytm");
      if (paytmTender && Object.keys(paytmTender).length > 0) set_tender(paytmTender);

      await paytmPayment({
        store_id: storeInfo?.store_id,
        amount,
        total_tax,
        updateOrderStatus: handlePaymentCallback,
        customer: customer || {},
        orders: [updatedActiveOrder],
        setBtnDisable: () => { },
      });
    } else {
      // Fallback for Cash / Skip payment (mark as CLOSE)
      const cashTender = findTenderByType("cash") || findTenderByType("ca");
      if (cashTender && Object.keys(cashTender).length > 0) set_tender(cashTender);

      await updateOrderStatus({
        paymentResponse: { type: "cash" },
        orders: [updatedActiveOrder],
      }, "CLOSE");
    }
  };

  const formatOrderDate = (dateStr) => {
    if (!dateStr) return "";
    const cleanDateStr = String(dateStr).replace(/Z$|[\+\-]\d{2}:\d{2}$/i, "");
    const date = moment(cleanDateStr);
    return date.isValid() ? date.format("DD MMM YYYY, hh:mm a") : dateStr;
  };

  // Render variables
  const logo = storeInfo?.store_display_logo || defaultimg;
  const storeName = storeInfo?.store_name || "FFS";
  const activeColor = primaryColor;
  const baseColor = activeColor.startsWith("#") && activeColor.length === 7 ? activeColor : "#3159A6";
  const activeBg = activeColor.startsWith("#") && activeColor.length === 7 ? `${activeColor}1A` : "#E3F2FD";
  const primaryFilter = (() => {
    try {
      const filterRes = hexToCSSFilter(activeColor);
      return `brightness(0) ${filterRes.filter}`;
    } catch (e) {
      console.error("Error computing CSS filter for EmptyOrder:", e);
      return "";
    }
  })();
  const phoneVal = customer?.cust_mobile || "Enter Phone No.";

  const recalculatedTotals = (() => {
    let itemTotal = 0;
    let tax = 0;
    let discount = 0;

    if (activeOrder && Array.isArray(activeOrder.item_details)) {
      activeOrder.item_details.forEach(item => {
        if (item.is_void || item.isVoid || item.is_refund) return;
        if (item.main_item_id) return;
        const itemDiscount = parseFloat(item.discount || item.discount_amount || item.total_discount || 0);
        const itemTax = Array.isArray(item.tax) && item.tax.length > 0
          ? item.tax.reduce((s, t) => s + parseFloat(t.tax_amount || t.amount || 0), 0)
          : parseFloat(item.taxAmount || item.total_item_tax || 0);

        let price = parseFloat(item.sub_total || item.total_net_sale || 0);
        const netSale = parseFloat(item.total_net_sale || 0);

        // If sub_total matches netSale but there is a discount, sub_total might be post-discount
        if (itemDiscount > 0 && Math.abs(price - netSale) < 0.01 && price > 0) {
          // Add discount back to get the pre-discount price
          price = price + itemDiscount;
        }

        itemTotal += price;
        tax += itemTax;
        discount += itemDiscount;
      });
    }

    tax = parseFloat(tax.toFixed(2));
    const calculatedTotal = itemTotal - discount + tax;

    // Apply round off logic matching Index.js
    const roundOffSetting = storeInfoConfig?.general_config?.round_off;
    const isRoundOffApplicable = roundOffSetting === true || roundOffSetting === "true";
    const roundOffType = (storeInfoConfig?.general_config?.type || storeInfoConfig?.general_config?.round_off_type || "nearest").toLowerCase();

    let roundedTotal = calculatedTotal;
    if (isRoundOffApplicable && calculatedTotal > 0) {
      if (roundOffType === "up") {
        roundedTotal = Math.ceil(calculatedTotal);
      } else if (roundOffType === "down") {
        roundedTotal = Math.floor(calculatedTotal);
      } else {
        roundedTotal = Math.round(calculatedTotal);
      }
    }

    const finalTotal = roundedTotal > 0 ? roundedTotal : (activeOrder?.grand_total || activeOrder?.rounded_total || activeOrder?.total || 0);
    const roundOffAmount = parseFloat((finalTotal - calculatedTotal).toFixed(2));

    return {
      itemTotal,
      tax,
      discount,
      total: finalTotal,
      unroundedTotal: calculatedTotal,
      roundOffAmount,
    };
  })();

  const totalItemsCount = activeOrder?.item_details?.filter(item => !item.is_void && !item.isVoid && !item.is_refund && !item.main_item_id).reduce((acc, item) => acc + (item.quantity || 0), 0) || 0;
  const grandTotal = recalculatedTotals.total;

  if (isLoading) {
    return (
      <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "80vh" }}>
        <CircularProgress style={{ color: activeColor }} />
      </Grid>
    );
  }

  return (
    <>
      <style>
        {`
          .fsr-orders-page, .fsr-orders-page * {
            font-family: 'Inter', sans-serif !important;
          }
          @keyframes plate-pulse {
            0% {
              transform: scale(0.96);
              box-shadow: 0 0 0 0 ${baseColor}26, 0 0 0 12px ${baseColor}0D;
            }
            50% {
              transform: scale(1.04);
              box-shadow: 0 0 0 15px ${baseColor}0D, 0 0 0 35px ${baseColor}00;
            }
            100% {
              transform: scale(0.96);
              box-shadow: 0 0 0 0 ${baseColor}26, 0 0 0 12px ${baseColor}0D;
            }
          }
          .animated-plate {
            animation: plate-pulse 3s infinite ease-in-out;
            transition: all 0.3s ease-in-out;
          }
        `}
      </style>
      <div className="fsr-orders-page" style={{
        backgroundColor: "#ffffff",
        minHeight: "100dvh",
        paddingBottom: activeTab === "pay" ? "290px" : "160px"
      }}>
        {/* Curved Header Navbar (Matches /menu screen) */}
        <div
          style={{
            backgroundColor: "#ffffff",
            borderBottomLeftRadius: "24px",
            borderBottomRightRadius: "24px",
            borderBottom: `4px solid ${activeColor}`,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
            width: "100%",
            boxSizing: "border-box",
            paddingBottom: "4px"
          }}
        >
          <div
            style={{
              margin: "0",
              padding: "8px",
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
            }}
          >
            {/* Left element: Chevron Back button + Logo */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flex: "0 0 auto",
                marginRight: "8px",
              }}
            >
              <IconButton
                style={{
                  color: "black",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  borderRadius: "8px",
                  padding: "4px",
                  marginRight: "4px"
                }}
                onClick={() => navigate("/menu")}
              >
                <ChevronLeftTwoToneIcon style={{ fontSize: "20px" }} />
              </IconButton>
              <img
                src={logo}
                alt={storeName}
                style={{
                  maxWidth: storeInfo?.store_id === "1300" ? "48px" : "70px",
                  height: "auto",
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultimg;
                }}
              />
            </div>

            {/* Center element: Table No badge */}
            {activeOrder && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  marginLeft: "16px",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    backgroundColor: activeBg,
                    color: activeColor,
                    borderRadius: "8px",
                    padding: "6px 14px",
                    fontWeight: "700",
                    fontFamily: "Inter",
                    fontSize: "16px"
                  }}
                >
                  Table No. {getFSRTableDisplayName()}
                </div>
              </div>
            )}

            {/* Right element: Hamburger Menu Button */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                flex: "0 0 auto",
                marginLeft: "8px"
              }}
            >
              <IconButton onClick={handleSidebarOpen} style={{ padding: "8px" }}>
                <MenuIcon fontSize="large" style={{ color: activeColor }} />
              </IconButton>
            </div>
          </div>
        </div>

        {/* Customer Phone Details Card */}
        {activeTab !== "pay" && (
          <div
            style={{
              // backgroundColor: "#ffffff",
              // borderRadius: "12px",
              margin: "16px",
              padding: "12px",
              paddingLeft: "28px",
              paddingRight: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
              // border: "1px solid #f1f5f9"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flex: 1,
                backgroundColor: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                padding: "7px 14px",
                marginRight: "12px",
                visibility: (activeOrder && activeOrder.item_details?.length > 0) ? "visible" : "hidden"
              }}
            >
              <PhoneIcon style={{ color: activeColor, fontSize: "20px" }} />
              <Typography
                style={{
                  fontFamily: "Satoshi",
                  fontSize: "14px",
                  fontWeight: customer?.cust_mobile ? "500" : "400",
                  color: customer?.cust_mobile ? "#999999" : "#999999"
                }}
              >
                {phoneVal}
              </Typography>
            </div>

            {/* <Button
              onClick={() => setOpenUserInfo(true)}
              variant="contained"
              disableElevation
              style={{
                backgroundColor: activeColor,
                color: "#ffffff",
                borderRadius: "8px",
                textTransform: "none",
                padding: "4px 20px",
                fontWeight: "700",
                fontFamily: "Satoshi",
                fontSize: "14px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%", justifyContent: "center" }}>
                <EditIcon style={{ fontSize: "20px" }} />
                <span style={{fontSize:"18px", fontFamily:"Inter", fontWeight: "400"}}>
                Edit
                </span>
              </span>
            </Button> */}
          </div>
        )}

        {/* {activeOrder && activeTab !== "pay" && ( */}
        <Typography
          style={{
            fontFamily: "Plus Jakarta Sans",
            fontSize: "15px",
            fontWeight: "500",
            color: "#666666",
            margin: "14px 16px 14px 20px",
            textAlign: "left"
          }}
        >
          {activeOrder && activeTab !== "pay" && (
            <span style={{ fontSize: "18px" }}>
              Running Order
            </span>
          )}
        </Typography>


        {activeOrder ? (
          <>
            {/* Running Order Card Details */}
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                margin: "0 16px 16px 16px",
                padding: "16px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
                border: "1px solid #f1f5f9",
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    style={{
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: activeColor
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      Order No. {activeOrder?.invoice_no || activeOrder?.orderNo || activeOrder?.order_no || "1"}
                    </span>
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Inter",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: activeColor,
                      marginTop: "4px"
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      Table No. {getFSRTableDisplayName()}
                    </span>
                  </Typography>
                </div>
                <div style={{ textAlign: "right" }}>
                  <Typography
                    style={{
                      fontFamily: "Inter",
                      fontSize: "12px",
                      color: activeColor,
                      fontWeight: "700"
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      Order Placed on
                    </span>
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontWeight: "700",
                      color: activeColor,
                      marginTop: "4px"
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {formatOrderDate(activeOrder?.date_time || activeOrder?.created_at)}
                    </span>
                  </Typography>
                </div>
              </div>

              <Divider style={{ backgroundColor: "#f1f5f9" }} />

              {/* Placed Items List */}
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {groupItems(activeOrder.item_details)?.map((item, index) => {
                  const isVeg = item.dietary === "veg" || (String(item.dietary).toLowerCase().includes("veg") && !String(item.dietary).toLowerCase().includes("non"));
                  const displayPrice = getCumulativePrice(item, item.subItems);

                  const modifiersList = [];
                  if (item?.selected_modifier) {
                    item.selected_modifier.forEach(sm => {
                      sm?.modifiers?.forEach(m => {
                        if (m?.modifier_name) modifiersList.push(m.modifier_name);
                      });
                    });
                  }

                  const groupedAddons = {};
                  const registerAddon = (name, variant) => {
                    if (!name) return;
                    const baseName = name.trim();
                    const varName = (variant || "").trim();
                    if (!groupedAddons[baseName]) {
                      groupedAddons[baseName] = new Set();
                    }
                    if (varName && varName.toLowerCase() !== "regular") {
                      groupedAddons[baseName].add(varName);
                    }
                  };

                  const processFsrAddon = (addon) => {
                    if (!addon) return;
                    const name = addon.item_name || addon.name || addon.item_variant?.[0]?.item_name;
                    const variant = addon.variant_name || addon.item_variant?.[0]?.variant_name;
                    registerAddon(name, variant);
                  };

                  if (item?.selectedAddonsItems) item.selectedAddonsItems.forEach(processFsrAddon);
                  if (item?.selected_addons_items) item.selected_addons_items.forEach(processFsrAddon);
                  if (item?.subItems) item.subItems.forEach(processFsrAddon);

                  Object.keys(groupedAddons).forEach(baseName => {
                    const variantsSet = groupedAddons[baseName];
                    if (variantsSet.size > 0) {
                      const variantsString = Array.from(variantsSet).join(", ");
                      modifiersList.push(`${baseName}- ${variantsString}`);
                    } else {
                      modifiersList.push(baseName);
                    }
                  });

                  const uniqueModifiers = modifiersList
                    .filter(Boolean)
                    .map(name => name.replace(/\s*Regular\b/i, ""))
                    .filter((value, index, self) => self.indexOf(value) === index);
                  const addonsText = uniqueModifiers.join(", ");

                  const isItemVoid = item.is_void || item.isVoid || item.is_refund;

                  return (
                    <div key={index}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          opacity: isItemVoid ? 0.6 : 1
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", textAlign: "left" }}>
                          <img
                            src={isVeg ? VegIcon : NonVegIcon}
                            alt={item.dietary || "veg"}
                            style={{ width: "16px", height: "16px", filter: isItemVoid ? "grayscale(100%)" : "none" }}
                          />
                          <Typography
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: isItemVoid ? "#94a3b8" : "#1e293b",
                              textDecoration: isItemVoid ? "line-through" : "none"
                            }}
                          >
                            {item.quantity} X {item.item_name}
                          </Typography>
                        </div>
                        <Typography
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "14px",
                            fontWeight: "700",
                            color: isItemVoid ? "#94a3b8" : activeColor,
                            textDecoration: isItemVoid ? "line-through" : "none",
                            whiteSpace: "nowrap",
                            flexShrink: 0
                          }}
                        >
                          {currencySymbol} {parseFloat(displayPrice).toFixed(2)}
                        </Typography>
                      </div>
                      {addonsText && (
                        <div
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "12px",
                            color: "#64748b",
                            textAlign: "left",
                            paddingLeft: "26px",
                            marginTop: "2px",
                            textDecoration: isItemVoid ? "line-through" : "none"
                          }}
                        >
                          {addonsText}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Add More Items Button */}
            {activeTab !== "pay" && (
              <button
                onClick={() => navigate("/menu")}
                style={{
                  borderColor: activeColor,
                  color: activeColor,
                  borderStyle: "solid",
                  borderWidth: "1.5px",
                  borderRadius: "8px",
                  padding: "4px 12px",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  marginLeft: "16px",
                  outline: "none"
                }}
              >
                <AddIcon style={{ fontSize: "28px", color: activeColor }} />
                <span style={{ fontSize: "16px", color: activeColor }}>Add More Items</span>
              </button>
            )}

            {/* Summary of Total and Tax (Shown in Pay Bill layout at the bottom, matching Index.js of cart) */}
            {activeTab === "pay" && (
              <div
                style={{
                  position: "fixed",
                  bottom: "144px", // Above bottom action tray (64px DiningFooter + 80px tray = 144px)
                  ...frameFixed,
                  backgroundColor: "#ffffff",
                  boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.04)",
                  borderTop: "1px solid #f1f5f9",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  padding: "16px 20px",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  zIndex: 999
                }}
              >
                {cartProps?.storeOffer?.length ? (
                  <button
                    onClick={() => setCouponOpen(true)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      border: `1.5px solid ${activeColor}`,
                      background: "#ffffff",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "0.5rem",
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                      <img
                        src={CouponImg}
                        alt="coupon"
                        style={{
                          width: "18px",
                          height: "18px",
                          objectFit: "contain",
                          filter: `brightness(0) ${hexToCSSFilter(activeColor || "#000000").filter}`,
                        }}
                      />
                      <span style={{ fontSize: "14px", fontWeight: "600", color: "#333333" }}>
                        {cartProps?.appliedOffer ? "Change / Remove Offer" : "Apply Coupon"}
                      </span>
                    </span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 18l6-6-6-6" stroke={activeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                ) : null}
                {storeInfoConfig?.web_ordering_setting?.tip_option_qr ? (
                  <Grid container style={{ paddingBottom: "0.25rem" }}>
                    <Grid container justifyContent="center" xs={12} sm={12} md={12} lg={12}>
                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        <Typography
                          style={{
                            padding: "0.5rem 0rem",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Tip
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={9}
                        sm={9}
                        md={9}
                        lg={9}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <RadioGroup
                          sx={{ gap: 1.5, display: "flex", flexDirection: "row" }}
                          value={tipValue}
                          onChange={(event) => {
                            if (event.target.value === "No Tip") {
                              setTipValue(event.target.value);
                              store.dispatch(addTip(parseFloat(0.00)));
                            } else {
                              setTipValue(event.target.value);
                              store.dispatch(addTip(parseFloat(event.target.value)));
                            }
                          }}
                        >
                          {[10, 15, 20, "No Tip"].map((e) => {
                            const displayLabel = typeof e === "number" ? `${currencySymbol} ${e}` : e;
                            return (
                              <Sheet
                                key={e}
                                sx={{
                                  p: 1,
                                  borderRadius: "md",
                                  boxShadow: "sm",
                                }}
                              >
                                <Radio
                                  label={displayLabel}
                                  overlay
                                  size="small"
                                  value={e}
                                  disableIcon
                                  slotProps={{
                                    label: ({ checked }) => ({
                                      sx: {
                                        fontSize: "sm",
                                        color: checked ? "black" : "black",
                                      },
                                    }),
                                    action: ({ checked }) => ({
                                      sx: (theme) => ({
                                        ...(checked && {
                                          "--variant-borderWidth": "2px",
                                          "&&": {
                                            borderColor: "#dee7ee",
                                            background: "#dee7ee",
                                          },
                                        }),
                                      }),
                                    }),
                                  }}
                                />
                              </Sheet>
                            );
                          })}
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "left" }}>
                    Item Total
                  </Typography>
                  <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "right" }}>
                    {currencySymbol} {parseFloat(recalculatedTotals.itemTotal || 0).toFixed(2)}
                  </Typography>
                </div>
                {(cartProps?.tip || 0) > 0 && (
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "left" }}>
                      Tip
                    </Typography>
                    <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "right" }}>
                      {currencySymbol} {parseFloat(cartProps.tip || 0).toFixed(2)}
                    </Typography>
                  </div>
                )}
                {(cartProps?.engineDiscount?.total_discount || 0) > 0 && (
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "left" }}>
                      Discount
                    </Typography>
                    <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "right" }}>
                      -{currencySymbol} {parseFloat(cartProps.engineDiscount.total_discount || 0).toFixed(2)}
                    </Typography>
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "left" }}>
                    Tax
                  </Typography>
                  <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: activeColor, fontWeight: "500", textAlign: "right" }}>
                    {currencySymbol} {parseFloat(cartProps?.engineDiscount?.total_item_tax ?? recalculatedTotals.tax ?? 0).toFixed(2)}
                  </Typography>
                </div>
                <Divider style={{ backgroundColor: "#f1f5f9", margin: "6px 0" }} />
                {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography style={{ fontFamily: "Inter", fontSize: "16px", color: "#1e293b", fontWeight: "600", textAlign: "left" }}>
                    Total
                  </Typography>
                  <Typography style={{ fontFamily: "Satoshi", fontSize: "18px", color: "#1e293b", fontWeight: "600", textAlign: "right" }}>
                    {currencySymbol} {parseFloat(grandTotal || 0).toFixed(2)}
                  </Typography>
                </div> */}
              </div>
            )}

            {/* Bottom Summary Action Tray */}
            <div
              style={{
                position: "fixed",
                bottom: "64px",
                ...frameFixed,
                height: "80px",
                backgroundColor: "#ffffff",
                borderTop: "1px solid #f1f5f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 20px",
                zIndex: 1000,
                boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.03)",
                boxSizing: "border-box"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    border: "1px solid #f1f5f9",
                    boxShadow: "0px 0px 4px 0px #0000001F",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <img alt="cart" width={"17px"} height={"17px"} src={cart} style={{ display: "block" }} />
                </div>
                <Typography
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: "#1e293b"
                  }}
                >
                  {totalItemsCount} {totalItemsCount === 1 ? "Item" : "Items"}
                </Typography>
              </div>

              <Button
                onClick={() => {
                  if (activeTab === "orders") {
                    store.dispatch({ type: 'SET_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo, data: { payBillEnabled: true } } });
                    navigate("/cart", {
                      state: {
                        fsrView: "orders",
                        activeTab: "pay"
                      }
                    });
                  } else {
                    // Preserve any offer applied on this pay-bill screen through
                    // the /checkout navigation. The engineDiscount override in
                    // recalculatedTotals propagates the discounted amount too.
                    proceedingToCheckoutRef.current = true;
                    const engineGrand = cartProps?.engineDiscount?.transaction_grand_amount;
                    const grandForCheckout = engineGrand != null ? engineGrand : recalculatedTotals?.total;
                    navigate("/checkout", {
                      state: {
                        isFSROrder: true,
                        activeOrder: activeOrder,
                        recalculatedTotals: { ...recalculatedTotals, total: grandForCheckout }
                      }
                    });
                  }
                }}
                variant="contained"
                disableElevation
                style={{
                  backgroundColor: activeColor,
                  color: "#ffffff",
                  borderRadius: "8px",
                  textTransform: "none",
                  padding: "10px 18px",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  fontSize: "16px",
                  minWidth: "210px",
                  height: "46px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    gap: "10px"
                  }}
                >
                  <span style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: "4px"
                  }}>
                    {`Pay Now (${currencySymbol}${parseFloat(
                      activeTab === "orders"
                        ? ((recalculatedTotals?.itemTotal || 0) - (recalculatedTotals?.discount || 0))
                        : ((cartProps?.engineDiscount?.transaction_grand_amount != null
                          ? cartProps.engineDiscount.transaction_grand_amount
                          : ((recalculatedTotals?.itemTotal || 0) - (recalculatedTotals?.discount || 0) + (recalculatedTotals?.tax || 0)))
                          + parseFloat(cartProps?.tip || 0))
                    ).toFixed(2)})`}
                    <ArrowForwardIcon style={{ fontSize: "20px" }} />
                  </span>
                </div>
              </Button>
            </div>
            {activeTab === "pay" && activeOrder && (
              <FSRPayBillOffers
                open={couponOpen}
                setOpen={setCouponOpen}
                activeOrder={activeOrder}
              />
            )}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 24px",
              boxSizing: "border-box"
            }}
          >
            {/* Circular Plate Design */}
            <div
              className="animated-plate"
              style={{
                width: "180px",
                height: "180px",
                borderRadius: "50%",
                backgroundColor: activeColor.startsWith("#") && activeColor.length === 7 ? `${activeColor}1A` : "rgba(49, 89, 166, 0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "10px"
              }}
            >
              <div
                style={{
                  width: "130px",
                  height: "130px",
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.06)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {/* EmptyOrder Image with CSS Filter */}
                <img
                  src={EmptyOrder}
                  alt="Empty Order"
                  style={{
                    width: "56px",
                    height: "56px",
                    filter: primaryFilter,
                    objectFit: "contain"
                  }}
                />
              </div>
            </div>

            {/* Dashed Separator Line */}
            <svg width="90%" height="2" style={{ margin: "24px 0", opacity: 1 }}>
              <line
                x1="0"
                y1="1"
                x2="100%"
                y2="1"
                stroke="#CCCCCC"
                strokeWidth="1"
                strokeDasharray="7,7"
              />
            </svg>

            {/* Heading text */}
            <Typography
              style={{
                fontFamily: "Satoshi",
                fontSize: "20px",
                fontWeight: "500",
                color: "#333333",
                marginBottom: "12px",
                textAlign: "center"
              }}
            >
              <span style={{ fontSize: "21px", fontFamily: "Inter", fontWeight: "500" }}>
                Your table is all set!
              </span>
            </Typography>

            {/* Description text */}
            <Typography
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                color: "#999999",
                lineHeight: "1.5",
                textAlign: "center",
                maxWidth: "300px",
                marginBottom: "32px"
              }}
            >
              No order has been placed yet. Head over to the menu and pick your favourites.
            </Typography>

            {/* Browse Menu Box with primary color background */}
            <div
              onClick={() => navigate("/menu")}
              style={{
                backgroundColor: activeColor,
                borderRadius: "12px",
                padding: "16px 24px",
                width: "100%",
                maxWidth: "310px",
                textAlign: "center",
                cursor: "pointer",
                boxShadow: `0px 4px 14px ${activeColor}33`,
                boxSizing: "border-box"
              }}
            >
              <Typography
                style={{
                  fontFamily: "Satoshi",
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#ffffff"
                }}
              >
                <span style={{ fontSize: "21px", fontFamily: "Inter", fontWeight: "600" }}>
                  Browse Menu
                </span>
              </Typography>
              <Typography
                style={{
                  fontFamily: "Inter",
                  fontSize: "2px !important",
                  color: "#FFFFFFB0",
                  opacity: 0.8,
                  marginTop: "4px"
                }}
              >
                <span style={{ fontSize: "14px", fontFamily: "Inter" }}>
                  Explore starters, mains, desserts & more
                </span>
              </Typography>
            </div>
          </div>
        )}
      </div>

      {/* Global Edit Phone / OTP Popup */}
      <SignInPopup
        {...props}
        {...{
          openUserInfo,
          setOpenUserInfo,
          customer: storeInfoConfig?.web_ordering_setting?.is_customer_screen_qr,
          storeInfo,
          storeInfoConfig,
        }}
      />

      {/* Hamburger Menu Sidebar Drawer */}
      <Drawer
        anchor="right"
        open={openSidebar}
        onClose={handleSidebarClose}
        PaperProps={{
          style: {
            backgroundColor: "#FAFAFA",
            borderRadius: "0px",
          },
        }}
      >
        <Box
          sx={{
            width: 320,
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          }}
          role="presentation"
          onClick={handleSidebarClose}
          onKeyDown={handleSidebarClose}
        >
          <div>
            {storeInfoConfig?.web_ordering_setting?.is_menu ? (
              ""
            ) : (
              <>
                {/* User Profile Section */}
                <div
                  style={{
                    padding: "16px 24px",
                    background: activeColor,
                    color: "white",
                    borderRadius: "0px",
                    marginBottom: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenUserInfo(true);
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        background: activeColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.5556 8.44444C10.5556 6.20484 11.4452 4.05696 13.0289 2.47332C14.6125 0.88968 16.7604 0 19 0C21.2396 0 23.3875 0.88968 24.9711 2.47332C26.5548 4.05696 27.4444 6.20484 27.4444 8.44444C27.4444 10.6841 26.5548 12.8319 24.9711 14.4156C23.3875 15.9992 21.2396 16.8889 19 16.8889C16.7604 16.8889 14.6125 15.9992 13.0289 14.4156C11.4452 12.8319 10.5556 10.6841 10.5556 8.44444ZM10.5556 21.1111C7.75605 21.1111 5.0712 22.2232 3.09165 24.2028C1.1121 26.1823 0 28.8672 0 31.6667C0 33.3464 0.66726 34.9573 1.85499 36.145C3.04272 37.3327 4.65363 38 6.33333 38H31.6667C33.3464 38 34.9573 37.3327 36.145 36.145C37.3327 34.9573 38 33.3464 38 31.6667C38 28.8672 36.8879 26.1823 34.9084 24.2028C32.9288 22.2232 30.244 21.1111 27.4444 21.1111H10.5556Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "700",
                          marginBottom: "4px",
                          fontFamily: "Satoshi"
                        }}
                      >
                        {customer !== null && customer?.cust_first_name
                          ? customer.cust_first_name
                          : "Guest User"}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          opacity: 0.9,
                          fontSize: "14px",
                          fontFamily: "Satoshi"
                        }}
                      >
                        Tap to manage account
                      </Typography>
                    </div>
                  </div>
                </div>
                {/* Navigation Menu */}
                {!(sessionReducer?.is_fsr === true) && (
                  <div style={{ padding: "0 16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 16px",
                        borderRadius: "16px",
                        backgroundColor: "white",
                        marginBottom: "12px",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => {
                        if (props.clear_customer) {
                          props.clear_customer();
                        }
                        if (props.addedItems?.length > 0) {
                          setOpenLeaveCartPopup(true);
                        } else {
                          navigate("/");
                        }
                      }}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "3px",
                        }}
                      >
                        <HomeIcon
                          style={{ color: activeColor, fontSize: "40px" }}
                        />
                      </div>
                      <Typography
                        style={{
                          fontWeight: "600",
                          color: "#333",
                          fontSize: "24px",
                          fontFamily: "Satoshi"
                        }}
                      >
                        <span style={{ fontSize: "18px" }}>Home</span>
                      </Typography>
                    </div>
                  </div>
                )}{" "}
                {/* Show Recent Order only if customer details exist */}
                {customer !== null && customer?.cust_first_name && (
                  <div style={{ padding: "0 16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "16px",
                        borderRadius: "16px",
                        backgroundColor: "white",
                        marginBottom: "12px",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => navigate("/customer")}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "3px",
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 19 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.3983 0.942773L16.3114 5.73696C16.3907 5.93602 16.4365 6.1164 16.469 6.32954L18.9838 21.211C19.1016 21.9089 18.5611 22.5445 17.8528 22.5406L12.5191 22.5135C12.4412 22.5142 12.3742 22.467 12.3464 22.3909C12.3182 22.3148 12.3368 22.2323 12.395 22.1781C12.682 21.9103 12.8639 21.52 12.8678 21.0866L13 6.3919L14.0496 0.978708C14.0658 0.894507 14.13 0.83391 14.2115 0.825807C14.2929 0.817352 14.3669 0.863504 14.3983 0.942773ZM7.73477 3.20458H10.4104C10.7013 3.20458 10.94 2.9548 10.94 2.6497V2.12758C10.94 1.82284 10.7013 1.5727 10.4104 1.5727H7.73477H5.05877C4.7679 1.5727 4.52921 1.82284 4.52921 2.12758V2.6497C4.52921 2.9548 4.7679 3.20458 5.05877 3.20458H7.73477ZM7.73477 0H12.835C13.0705 0 13.3096 0.207156 13.2627 0.447782L12.0996 6.3919L11.967 21.0866C11.96 21.8909 11.3391 22.5476 10.5719 22.5476H1.40122C0.633322 22.5476 -0.0732258 21.8871 0.00610221 21.0866L1.43894 6.60751L3.41967 0.447782C3.44859 0.203281 3.61182 0 3.84699 0H7.73477Z"
                            fill={activeColor}
                          />
                        </svg>
                      </div>
                      <Typography
                        style={{
                          fontWeight: "600",
                          color: "#333",
                          fontSize: "16px",
                          fontFamily: "Satoshi"
                        }}
                      >
                        <span style={{ fontSize: "18px" }}>Recent Order</span>
                      </Typography>
                    </div>
                  </div>
                )}
                {/* Legal & Support Links */}
                <div
                  style={{
                    marginTop: "30px",
                    padding: "16px",
                    borderTop: "1px solid #E0E0E0",
                  }}
                >
                  <Typography
                    variant="caption"
                    style={{
                      color: "#666",
                      fontWeight: "600",
                      marginBottom: "16px",
                      display: "block",
                      fontFamily: "Satoshi"
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>LEGAL & SUPPORT</span>
                  </Typography>

                  {[
                    { text: "About Us", path: "/aboutus" },
                    { text: "Privacy Policy", path: "/privacy-policy" },
                    { text: "Refund Policy", path: "/refund-policy" },
                    { text: "Shipping Policy", path: "/shipping-policy" },
                    { text: "Terms & Conditions", path: "/terms-condition" },
                    { text: "Contact Us", path: "/contactus" },
                  ].map((link, index, array) => (
                    <div
                      key={index}
                      style={{
                        padding: "6px 0",
                        borderBottom:
                          index < array.length - 1 ? "2px solid #F0F0F0" : "none",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(link.path)}
                    >
                      <Typography
                        style={{
                          color: "#333333",
                          fontSize: "21px",
                          fontWeight: "600",
                          fontFamily: "Satoshi"
                        }}
                      >
                        <span style={{ fontSize: "15px" }}>{link.text}</span>
                      </Typography>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Powered By Logo - Pushed to bottom */}
          {!storeInfoConfig?.web_ordering_setting?.is_menu && (
            <div
              style={{
                marginTop: "60px",
                padding: "16px 16px 24px 16px",
                textAlign: "center",
                backgroundColor: "#FAFAFA",
                borderTop: "1px solid #F0F0F0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <span
                  style={{
                    fontSize: "1.1rem",
                    color: "#A0AEC0",
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                  }}
                >
                  Powered By
                </span>
                <img
                  alt="Logo"
                  style={{ width: "80px", height: "auto" }}
                  src={CyntraLogo}
                />
              </div>
            </div>
          )}
        </Box>
      </Drawer>
      <LeaveCartPopup
        open={openLeaveCartPopup}
        onClose={() => setOpenLeaveCartPopup(false)}
        onConfirm={() => {
          setOpenLeaveCartPopup(false);
          if (props.clearCart) props.clearCart();
          navigate("/");
        }}
        storeInfo={storeInfo}
        storeInfoConfig={storeInfoConfig}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  reducer: state.customerReducer,
});

export default connect(mapStateToProps, { set_last_order, set_customer, clear_customer, order_place, clear_last_order })(FSROrders);
